<template>
  <bulma-autocomplete :placeholder="placeholder"
    v-model="innerValue"
    :data="items"
    :loading="false"
    field="assessorName"
    :disabled="disabled"
    @input="getAssessorList"
    @search="getAssessorList"
    @select="select">
    <template slot-scope="props">
      <div class="is-flex is-justify-content-space-between is-align-items-center">
        <div>
          <div class="is-flex is-align-items-center">
            <span class="icon is-small">
              <i class="mdi mdi-account mdi-18px" />
            </span>
            <span class="pl-1">{{ props.option.assessorName || 'no name' }}</span>
          </div>
          <div class="is-flex is-align-items-center">
            <span class="icon is-small">
              <i class="mdi mdi-phone mdi-14px" />
            </span>
            <span class="is-size-7 has-text-grey-light pl-1">{{ props?.option?.assessorPhoneNo || '-' }}</span>
          </div>
        </div>
        <div class="is-pulled-right">
          <span class="tag"
            :class="{
              'is-success': props.option.source === 'Customer',
              'is-info': props.option.source === 'Insurer',
              'is-light': props.option.source === 'Assessor'
            }"
            v-if="props.option.source">
            {{ props.option.source }}
          </span>
        </div>
      </div>
    </template>
  </bulma-autocomplete>
</template>

<script>
import { BulmaAutocomplete } from '@/components/BulmaAutocomplete'
import { QuoteService, CustomerService } from '@/services'
import _debounce from 'lodash.debounce'

export default {
  name: 'AssessorAutocomplete',
  components: {
    BulmaAutocomplete
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    quoteId: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Assessor'
    }
  },
  data: () => {
    return {
      items: [],
      innerValue: ''
    }
  },
  watch: {
    innerValue(newVal, oldVal) {
      this.$emit('input', newVal)
    },
    value: {
      handler: function (newVal, oldVal) {
        this.innerValue = newVal || ''
      },
      immediate: true
    }
  },
  methods: {
    getAssessorList: _debounce(async function (query) {
      const search = query ? query.replace(/[^a-zA-Z\s]/g, '') : ''
      if (!search) {
        this.items = []
        return
      }
      const [contacts, assessors] = await Promise.all([
        CustomerService.getQuoteInsurerCustomerContacts(this.quoteId, search).catch(() => []),
        QuoteService.getQuoteAssessorList(search).catch(() => [])
      ])
      const contactItems = contacts.map((c) => ({
        assessorName: c.fullName,
        assessorPhoneNo: c.phoneNo,
        source: c.groupName
      }))
      const assessorItems = assessors.map((a) => ({
        ...a,
        source: 'Assessor'
      }))
      this.items = this.dedupe([...contactItems, ...assessorItems])
    }, 100),
    dedupe(items) {
      const seen = new Set()
      return items.filter((item) => {
        const key = `${(item.assessorName || '').toLowerCase().trim()}|${this.keepOnlyDigits(item.assessorPhoneNo || '')}`
        if (seen.has(key)) {
          return false
        }
        seen.add(key)
        return true
      })
    },
    keepOnlyDigits(str) {
      return str.replace(/\D/g, '')
    },
    select(selectedItem) {
      if (selectedItem) {
        selectedItem.assessorPhoneNo = this.keepOnlyDigits(selectedItem.assessorPhoneNo || '')
      }
      this.$emit('select', selectedItem)
    }
  }
}
</script>
